var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.logOut}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['fas', 'sign-out']}}),_vm._v("\n  Uitloggen\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }